// extracted by mini-css-extract-plugin
export default {"container":"ImageComparison_container__Z9wAl"};